export function catalogContactRedirect(dogId: string) {
    return {
        to: "/dog/$dogId" as const,
        params: { dogId },
        statusCode: 302,
        replace: true,
    };
}
